import React, { useMemo } from 'react';
import { getMediaClient } from './getMediaClient';
import { useMediaParsedSettings } from './mediaSettings';
export var MediaContext = /*#__PURE__*/React.createContext(undefined);
export var MediaProvider = function MediaProvider(_ref) {
  var children = _ref.children,
    mediaClientConfig = _ref.mediaClientConfig,
    mediaSettings = _ref.mediaSettings;
  var mediaClient = useMemo(function () {
    return getMediaClient(mediaClientConfig);
  }, [mediaClientConfig]);
  var settings = useMediaParsedSettings(mediaSettings);
  return /*#__PURE__*/React.createElement(MediaContext.Provider, {
    value: {
      mediaClient: mediaClient,
      settings: settings
    }
  }, children);
};